var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPpl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_604_56978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.28125 5.00537C4.57198 5.00537 3.18229 6.39506 3.18229 8.10433C3.18229 9.8136 4.57198 11.2033 6.28125 11.2033C7.99052 11.2033 9.38021 9.8136 9.38021 8.10433C9.38021 6.39506 7.99052 5.00537 6.28125 5.00537ZM6.28125 11.2033C3.2065 11.2033 0.703125 13.7042 0.703125 16.7814H11.8594C11.8594 16.1737 11.748 15.5854 11.5688 15.0382C11.6318 14.9002 11.6996 14.7622 11.7819 14.6315C12.3872 13.6849 13.4379 13.0627 14.6484 13.0627C16.5393 13.0627 18.0573 14.5807 18.0573 16.4715V16.7814H19.2969V16.4715C19.2969 14.6727 18.2631 13.099 16.7596 12.3267C17.5489 11.702 18.0573 10.7336 18.0573 9.65381C18.0573 7.77749 16.5248 6.24495 14.6484 6.24495C12.7721 6.24495 11.2396 7.77749 11.2396 9.65381C11.2396 10.7433 11.7553 11.7214 12.5566 12.346C11.9151 12.6729 11.3582 13.128 10.9297 13.7018C9.92979 12.1983 8.2181 11.2033 6.28125 11.2033ZM14.6484 7.48454C15.8541 7.48454 16.8177 8.44812 16.8177 9.65381C16.8177 10.8595 15.8541 11.8231 14.6484 11.8231C13.4427 11.8231 12.4792 10.8595 12.4792 9.65381C12.4792 8.44812 13.4427 7.48454 14.6484 7.48454Z",
    fill: "#00A5FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_604_56978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.8333,
    height: 19.8333,
    fill: "white",
    transform: "translate(0.0830078 0.666992)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpl);
export default __webpack_public_path__ + "static/media/ppl.98497c371169b074b9c1fae71f3f3bec.svg";
export { ForwardRef as ReactComponent };